import clsx from 'clsx';
import type * as React from 'react';

import { CUSTOMIZATION_CONTENT_LINK_TITLE_MAX_LENGTH } from '@gitbook/api-client';
import { Description, FieldGroup, Label, TextInput } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';

/**
 * Settings to configure the message for the site announcement
 */
export function AnnouncementLinkTitleSettings(
    props: SitesCustomizationPanelProps
): React.ReactElement {
    const { settings, setSettings } = props;

    return (
        <FieldGroup orientation="vertical">
            <Label>Call to action</Label>
            <Description>An optional clickable text link, displayed after the message.</Description>
            <TextInput
                disabled={!settings.announcement?.link}
                value={settings.announcement?.link?.title}
                placeholder="Read the docs"
                maxLength={CUSTOMIZATION_CONTENT_LINK_TITLE_MAX_LENGTH}
                onChange={(event) => {
                    setSettings((prev) => ({
                        ...prev,
                        announcement: {
                            enabled: true,
                            message: '',
                            style: 'info',
                            ...prev.announcement,
                            link: prev.announcement?.link
                                ? {
                                      title: event.target.value,
                                      to: prev.announcement?.link?.to,
                                  }
                                : undefined,
                        },
                    }));
                }}
            />
            <div
                className={clsx(
                    'text-ui-small',
                    settings.announcement?.link?.title.length ===
                        CUSTOMIZATION_CONTENT_LINK_TITLE_MAX_LENGTH
                        ? 'text-danger'
                        : 'text-muted'
                )}
            >
                {settings.announcement?.link?.title.length ?? 0} /{' '}
                {CUSTOMIZATION_CONTENT_LINK_TITLE_MAX_LENGTH} characters
            </div>
        </FieldGroup>
    );
}
